// @owners { team: patients-team }
import {
  SET_ESSENTIALS_ACTIVE_CATEGORY,
  SET_ESSENTIALS_SEARCH_TERM,
  type SetActiveEssentialCategory,
  type SetEssentialsSearchTerm,
  UPDATE_ADD_TO_SHIPMENT_ERROR,
  type UpdateAddToShipmentErrorAction,
  VIEW_STORE,
  type ViewStore,
} from '~shared/features/essentials/actions';

type Action = ViewStore | UpdateAddToShipmentErrorAction | SetActiveEssentialCategory | SetEssentialsSearchTerm;

export type EssentialsState = {
  addToShipmentError: {
    error: string | null | undefined;
    quantityAdded: number | null | undefined;
  };
  viewStoreCount: number;
  activeCategory: number;
  searchTerm: string;
};

export const initialState: EssentialsState = {
  addToShipmentError: {
    error: null,
    quantityAdded: null,
  },
  viewStoreCount: 0,
  activeCategory: 0,
  searchTerm: '',
};

const essentials = (state: EssentialsState = initialState, action: Action): EssentialsState => {
  switch (action.type) {
    case VIEW_STORE: {
      return { ...state, viewStoreCount: state.viewStoreCount + 1 };
    }
    case UPDATE_ADD_TO_SHIPMENT_ERROR: {
      return {
        ...state,
        addToShipmentError: action.payload,
      };
    }
    case SET_ESSENTIALS_ACTIVE_CATEGORY: {
      return {
        ...state,
        activeCategory: action.payload,
      };
    }
    case SET_ESSENTIALS_SEARCH_TERM: {
      return {
        ...state,
        searchTerm: action.payload,
      };
    }
    default:
      return state;
  }
};

export default essentials;
